import { Box, Card, CardContent, Collapse, Grid, TableCell, TableRow, useTheme } from '@mui/material';
import {
  visibleShareIssueCols,
  visibleShareIssueDetailedCols,
  visibleShareIssueDetailedWideCols,
} from './Utils/constants';
import React from 'react';
import { ClassNames } from '@emotion/react';
import { TrackerDataType } from '../../shared/constants/constants';
import CellViewer from '../Cells/CellViewer';
import { SharedInteractionsCollapsedDataRowProps } from './Types/componentProps';
import { IssueKeys } from '../../shared/constants/IssueAndServiceKeys';

const emptyDropdownTable = {
  expert: [],
  communityMember: [],
  organization: [],
  audience: [],
  lead: [],
  journalist: [],
  outlet: [],
};

const SharedInteractionsCollapsedDataRow = (props: SharedInteractionsCollapsedDataRowProps) => {
  const { collapsed, issueCells } = props;
  const theme = useTheme();

  const renderDetailedViewCards = (col: IssueKeys, classes: Record<string, string>) => {
    let xs = 2;
    if (visibleShareIssueDetailedWideCols.includes(col)) {
      xs = 3;
    }
    return (
      <Grid item xs={xs} key={col}>
        <Card className={classes.hiddenCellCard}>
          <CardContent className={classes.cardContent}>
            <Box className={classes.cardName}>{col}</Box>
            <Box sx={{ p: 6, minHeight: '5vh' }}>
              <CellViewer
                type={TrackerDataType.MEDIA_INTERACTION}
                cells={issueCells}
                index={col}
                callback={() => {}}
                dropdownTable={emptyDropdownTable}
                openForm={() => {}}
                openSecondaryForm={() => {}}
                classes={classes}
                id={null}
                handleDrag={() => {}}
                handleDrop={() => {}}
                isDragActive={false}
                onEditItem={() => {}}
              />
            </Box>
          </CardContent>
        </Card>
      </Grid>
    );
  };

  if (!collapsed) {
    return null;
  }

  return (
    <ClassNames>
      {({ css }) => {
        const classes = {
          hiddenCellCard: css({
            flex: 1,
            alignSelf: 'flex-start',
            margin: 0,
            textAlign: 'center',
            border: 'none',
            borderRadius: 0,
            boxShadow: 'none',
          }),
          cardContent: css({
            padding: '0 !important',
            borderRadius: 0,
            border: 'none',
            boxShadow: 'none',
          }),
          cardName: css({
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: theme.palette.whiteScaleDarker.main,
            padding: 8,
            color: theme.palette.whiteScaleDarker.contrastText,
            fontWeight: 400,
          }),
          collapseWrapperInner: css({
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'row',
            width: '100%',
            border: '1px solid #e0e0e0',
            borderRadius: '4px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)',
          }),
          stackBox: css({
            display: 'flex',
            flexDirection: 'column',
            gap: '0.25rem',
            alignItems: 'flex-start',
          }),
          addLinkedButton: css({
            padding: 4,
          }),
        };

        return (
          <TableRow sx={{ display: collapsed ? 'table-row' : 'none', padding: '4px' }}>
            <TableCell
              colSpan={visibleShareIssueCols.length + 2}
              sx={{ padding: '10px', paddingLeft: '20px', paddingRight: '15px' }}
            >
              <Collapse in={collapsed} timeout={250} classes={{ wrapperInner: classes.collapseWrapperInner }}>
                <Grid container spacing={0}>
                  {visibleShareIssueDetailedCols.map((col) => renderDetailedViewCards(col, classes))}
                  {visibleShareIssueDetailedWideCols.map((col) => renderDetailedViewCards(col, classes))}
                </Grid>
              </Collapse>
            </TableCell>
          </TableRow>
        );
      }}
    </ClassNames>
  );
};

export default SharedInteractionsCollapsedDataRow;
